import moment from 'moment';

const ACCEPTED_FORMATS = ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY'];

// The room info endpoint only accepts ISO 8601 dates, so normalise the move-in date to YYYY-MM-DD.
// Returns an empty string when the date can't be parsed.
export const parseMoveInDate = (moveInDate?: string | null) => {
    if (!moveInDate) return '';

    const parsed = moment(moveInDate.trim(), ACCEPTED_FORMATS, true);

    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
};
